// frontend/src/api/CNASTDNRAFileApi.js (ejemplo)

import api from "./api";

// Obtener todos los archivos
export const fetchCNASTDNRAFiles = async () => {
  try {
    const response = await api.get("/cna-std-nra-files/");
    return response.data;
  } catch (error) {
    console.error("Error fetching CNA STD NRA file records:", error);
    throw error;
  }
};

// Obtener un archivo por ID
export const fetchCNASTDNRAFileById = async (id) => {
  try {
    const response = await api.get(`/cna-std-nra-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching CNA STD NRA file with ID ${id}:`, error);
    throw error;
  }
};

// Obtener archivos de propuesta
export const listCNASTDNRAFilesByProposal = async (proposalId) => {
  const response = await api.get(`/cna-std-nra-files/proposal/${proposalId}/`);
  return response.data;
};

// Buscar archivos por nombre (contiene)
export const searchCNASTDNRAFiles = async (query) => {
  try {
    const response = await api.get(`/cna-std-nra-files/?search=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error(`Error searching CNA STD NRA files with query "${query}":`, error);
    throw error;
  }
};

// Crear un nuevo archivo
export const createCNASTDNRAFile = async (data) => {
  try {
    const response = await api.post("/cna-std-nra-files/", data);
    return response.data;
  } catch (error) {
    console.error("Error creating CNA STD NRA file:", error);
    console.error("Error creating CNA STD NRA file:", error.response?.data || error.message);
    throw error;
  }
};

// Actualizar un archivo (solo si es del usuario)
export const updateCNASTDNRAFile = async (id, data) => {
  try {
    const response = await api.put(`/cna-std-nra-files/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating CNA STD NRA file with ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un archivo (solo si es del usuario)
export const softDeleteCNASTDNRAFile = async (id) => {
  try {
    const response = await api.delete(`/cna-std-nra-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error soft-deleting CNA STD NRA files:", error);
    throw error;
  }
};

// Exportar archivos CNA_STD_NRA_File por ID
export const exportCNASTDNRAFilesById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(`/cna-std-nra-files/export/?ids=${idsParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CNA STD NRA files by ID:", error);
    throw error;
  }
};

// Filtros generales
export const filterCNASTDNRAFiles = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/cna-std-nra-files/?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error filtering CNA STD NRA files:", error);
    throw error;
  }
};
